import axios from 'axios';
import { menuUrl } from '../env';
import { getAuthHeaders, cleanParams } from './utils';

import { CheckoutSettings } from '../interfaces/checkout_settings';
/* eslint-disable */
export const checkoutSettingsApi = {
  async getCheckoutSettings(r_id: number, qr_code: string) {
    return axios.get<CheckoutSettings[]>(
      `${menuUrl}/api/v1/checkout-settings/?merchant_id=${r_id}&qr_code_id=${qr_code}`,
      {
        headers: await getAuthHeaders(),
      },
    );
  },
};
